import { tracked } from '@glimmer/tracking';

import FilterSortGoalCompany from 'webapp/models-custom/filter-sort/goal-company';

export default class FilterSortGoalCompanyInList extends FilterSortGoalCompany {
	@tracked override viewId = 'table';
	override itemDomSelector = '.table-row:not(.empty)';
}
